import React from 'react';
import type { LayoutProps as BaseLayoutProps } from 'antd';

import { Content } from './styled.ts';

export const BaseContentLayout: React.FC<BaseLayoutProps> = ({ className, ...props }) => (
    <Content className={className} {...props} />
);
